import { ftClockCalendarFromArr, ftClockCampaignField, ftClockColsFromArr, ftCampaignTimeAddSeconds, type CampaignClockCols } from '../../shared/campaign-clock.js';
import { encounterCreatureField } from '../../shared/array-types.js';
import { getStatusEffectDurationTimes } from '../ability/statuses/get-status-effect-duration-times.js';
import { leanStatusEntry } from '../compile/status-row-construction.js';

type Row = Record<string, unknown>;
export interface SelfStatusClockReaders {
  campaign?: Row | null;
  campaignClock?: () => CampaignClockCols | null;
  value: (row: Row, key: string) => unknown;
}

/** One browser decision supplies both the fixed-column save and its lean projection.
 * Encounter-owned scenes keep their zero-based clock and turn expiry without a campaign. */
export function planSelfStatusSave(input: { statusId: string; itemId: string; actorId: string; connectedId: string },
  caster: Row, definition: Row, read: SelfStatusClockReaders): { row: Row; entry: Row } {
  const starts = read.campaignClock?.() ?? ftClockColsFromArr(read.campaign);
  const calendar = ftClockCalendarFromArr(read.campaign);
  const { ends, flags } = getStatusEffectDurationTimes({ read: {
    value: (target, key) => target ? read.value(target, key) : null,
    has: (target, key) => target != null && read.value(target, key) != null,
    campaignClock: () => starts,
    addCampaignSeconds: (clock, seconds) => ftCampaignTimeAddSeconds(clock, calendar, seconds),
  } }, definition, caster);
  const row: Row = {
    status_id: input.statusId, status_item_id: input.itemId, status_caster_id: input.actorId,
    status_target_id: input.actorId, status_connected_id: input.connectedId,
    status_stack: 1, status_private: Number(encounterCreatureField(caster.encounter_creatures, 'encounter_creature_private') ?? 0), status_deleted: 0,
    status_campaign_id: String(ftClockCampaignField(read.campaign, 'campaign_id') ?? '').toUpperCase(),
    status_ends_on_target_start_of_turn: flags[0], status_ends_on_target_end_of_turn: flags[1],
    status_ends_on_caster_start_of_next_turn: flags[2], status_ends_on_caster_end_of_next_turn: flags[3],
  };
  const end = ends.split('-').map(Number);
  (['year', 'month', 'day', 'hour', 'minute', 'second'] as const).forEach((unit, index) => {
    row[`status_starts_campaign_${unit}`] = starts[unit];
    row[`status_ends_campaign_${unit}`] = end[index];
  });
  return { row, entry: leanStatusEntry(row) as Row };
}
